import {  SearchOutlined, PlusCircleOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import styled from 'styled-components'
import { useState } from 'react'
import ModalCreateProduct from './ModalCreateProduct'

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;

  svg {
    position: relative;
    top: 1px;
  }

  button {
    height: 40px;
  }

  .wrap-button {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    flex-wrap: wrap;
  }
`

const ActionGroup = ({
  searchProduct,
  loadingList,
}: {
  searchProduct: () => void
  loadingList: boolean
}) => {
  const [modalCreateProduct, setModalCreateProduct] = useState<boolean>(false)
  const handleCancel = () => {
    searchProduct();
    setModalCreateProduct(false)
  }

  return (
    <Wrapper>
      <ModalCreateProduct
        open={modalCreateProduct}
        onCancel={() => handleCancel()}
      />
      <Button onClick={searchProduct} loading={loadingList} disabled={loadingList}>
        <SearchOutlined /> Tìm kiếm
      </Button>

      <div className='wrap-button'>
        {<Button
          onClick={() => setModalCreateProduct(true)}
        >
          <PlusCircleOutlined /> Thêm sản phẩm
        </Button>
        }
      </div>
    </Wrapper>
  )
}

export default ActionGroup
